"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateError = void 0;
const react_1 = require("react");
const ChartContext_1 = require("../context/ChartContext");
const LoggerContext_1 = require("../context/LoggerContext");
/**
 * Alert user in UI when state have errorAction (error from reducer)
 */
function StateError() {
    const { errorAction } = (0, ChartContext_1.useChartData)();
    const { logger } = (0, LoggerContext_1.useLogger)();
    (0, react_1.useEffect)(() => {
        if (!errorAction)
            return;
        logger.error(errorAction);
    }, [errorAction, logger]);
    return null;
}
exports.StateError = StateError;
